import { useState, useEffect, useRef } from 'react';

/**
 * Returns [ref, isVisible] — attach ref to the container element.
 * Once the element enters the viewport (with rootMargin buffer),
 * isVisible becomes true and stays true (no re-hiding).
 */
export default function useLazyRender(rootMargin = '200px') {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || isVisible) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin, isVisible]);

  return [ref, isVisible];
}
